/// <amd-module name="VSSUI/Components/VssIcon/index" />

export * from "./VssIcon";

// @NOTE: Explicit export list due to typescript compiler bug 18644 where a require is generated for export * when const enum's are present
export { VssIconType, IVssIconProps } from "./VssIcon.Props";
